(function () {
  var SESSION_KEY = 'hauck_geo_redirect_shown';

  function wasShownThisSession() {
    try {
      return window.sessionStorage.getItem(SESSION_KEY) === '1';
    } catch (error) {
      console.warn('geo-redirect-popup: sessionStorage unavailable, popup may show again this session', error);
      return false;
    }
  }

  function markShownThisSession() {
    try {
      window.sessionStorage.setItem(SESSION_KEY, '1');
    } catch (error) {
      console.warn('geo-redirect-popup: sessionStorage unavailable, popup may show again this session', error);
    }
  }

  // Intentional QA hook: lets support/QA verify region-specific behavior without a VPN.
  // Client-side and cosmetic only (just forces the modal open) - no data or security impact.
  function getDebugCountryOverride() {
    return new URLSearchParams(window.location.search).get('geo_debug');
  }

  function getTargetCountries(modal) {
    return (modal.dataset.countryCodes || '')
      .split(',')
      .map(function (code) {
        return code.trim().toUpperCase();
      })
      .filter(Boolean);
  }

  // localization.country in Liquid reflects the buyer's active Shopify Markets country,
  // not their real IP location - it stays fixed to this shop's configured markets even for
  // visitors from countries with no market at all. /browsing_context_suggestions.json is
  // Shopify's own IP-geolocation endpoint (the same signal the country/region selector uses)
  // and returns the real detected country regardless of market configuration.
  function getDetectedCountryCode() {
    return fetch('/browsing_context_suggestions.json', { headers: { Accept: 'application/json' } })
      .then(function (response) {
        return response.ok ? response.json() : null;
      })
      .then(function (data) {
        return (data && data.detected_values && data.detected_values.country && data.detected_values.country.handle) || null;
      })
      .catch(function (error) {
        console.warn('geo-redirect-popup: failed to detect visitor country', error);
        return null;
      });
  }

  function resolveShouldShow(modal) {
    var targetCountries = getTargetCountries(modal);
    if (targetCountries.length === 0) return Promise.resolve(false);

    var debugOverride = getDebugCountryOverride();
    if (debugOverride) {
      return Promise.resolve(targetCountries.indexOf(debugOverride.toUpperCase()) !== -1);
    }

    return getDetectedCountryCode().then(function (countryCode) {
      return !!countryCode && targetCountries.indexOf(countryCode.toUpperCase()) !== -1;
    });
  }

  function init() {
    var modal = document.querySelector('.geo-redirect-modal');
    if (!modal || wasShownThisSession()) return;

    resolveShouldShow(modal).then(function (shouldShow) {
      if (!shouldShow) return;

      markShownThisSession();
      modal.show();

      var stayButton = modal.querySelector('.geo-redirect-modal__stay');
      if (stayButton) {
        stayButton.addEventListener('click', function () {
          modal.hide();
          document.dispatchEvent(new CustomEvent('geo-redirect:stay'));
        });
      }

      var visitButton = modal.querySelector('.geo-redirect-modal__visit');
      if (visitButton) {
        visitButton.addEventListener('click', function () {
          document.dispatchEvent(new CustomEvent('geo-redirect:visit'));
        });
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
